module.exports = __webpack_public_path__ + "static/media/0047.1a55d2ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48107/Chassis_RAL/0047.png
// module id = 2629
// module chunks = 0